import React, { useState, useEffect } from 'react';
import '../styles/ConstructionPopup.css';

const ConstructionPopup = () => {
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        setShowPopup(true);
    }, []);

    const closePopup = () => {
        setShowPopup(false);
    };

    if (!showPopup) return null;

    return (
        <div className="construction-popup-overlay" onClick={closePopup}>
            <div className="construction-popup-content" onClick={(e) => e.stopPropagation()}>
                <button className="construction-popup-close" onClick={closePopup}>×</button>
                <div className="construction-popup-icon">🚧</div>
                <h2>Sito in Costruzione</h2>
                <p>Stiamo lavorando per offrirti un'esperienza migliore. Torna presto!</p>
                <button className="construction-popup-button" onClick={closePopup}>Ho capito</button>
            </div>
        </div>
    );
};

export default ConstructionPopup;
